<template>
  <div id="app">
    <router-view/>
    <div class="view" v-show="$route.path === '/dlView' || loading" :class="loading?'view-loading':'view-noloading'">
      <!-- <iframe frameborder="0" v-show="$route.path === '/dlView' || loading" id="tvView"
              :class="loading?'view-loading':(fullScreen ? 'fullScreen':'tvView')"
              ref="iframe"
              src="http://debug.nas.iamsee.com:2546/index.html"></iframe> -->
              <iframe frameborder="0" v-show="$route.path === '/dlView' || loading" id="tvView"
              :class="loading?'view-loading':(fullScreen ? 'fullScreen':'tvView')"
              ref="iframe"
              :src="'http://xl.tjopt.com:7090/'"></iframe>
               <!-- <iframe frameborder="0" v-show="$route.path === '/dlView' || loading" id="tvView"
              :class="loading?'view-loading':(fullScreen ? 'fullScreen':'tvView')"
              ref="iframe"
              src="http://localhost:3000/?id=8"></iframe> -->
    </div> 
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  data () {
    return {
      pageLoading: true,
      loading: true,
      loadingClass: {},
      time: {},
      classObject: {
        active: true,
        'text-danger': false
      },
      randomTime:0
    }
  },
  watch: {
    fullScreen (val) {
      console.log(val)
    }
  },
  created () {
    this.pageLoading = this.$loading({
      lock: true, // lock的修改符--默认是false
      text: '加载中', // 显示在加载图标下方的加载文案
      spinner: 'el-icon-loading', // 自定义加载图标类名
      background: 'rgba(255, 255, 255, 1)', // 遮罩层颜色
      target: document.querySelector('#table')// loadin覆盖的dom元素节点
    })

    window.appMessage = (data) => {
      console.log('data=>2222222', data)
      let {
        data: {
          status,
          msg,
          uuid
        }
      } = data

      if (uuid !== undefined) {
        console.log('msg=>', msg)
        if (msg === 'init-done') {
          this.pageLoading.close()
          this.loading = false
          let tvView = document.getElementById('tvView')
          window.tvView = tvView
          window.initDone = true
          window.removeEventListener('message', window.appMessage)
        }
      }
    }
    window.addEventListener('message', window.appMessage)
    this.time = setInterval(() => {
      this.check()
      console.log('心跳检测')
    }, 15000)
  },
  beforeDestroy () {
    clearInterval(this.time)
  },
  computed: {
    ...mapGetters([
      'user',
      'fullScreen'
    ])
  },
  methods: {
    ...mapActions([
      'saveUser'
    ]),
    check () {
      console.log(this.user)
      if (this.user) {
        this.$api.user.checkUser({ sessionKey: this.user.sessionKey, loggingCode: this.user.loggingCode }).then(res => {
          if (res.data.code === 200) {
            if (res.data.message === '' || res.data.message === null) {
            } else {
              window.localStorage.removeItem('user')
              this.$router.push({ path: '/home' })
              this.saveUser(null)
              this.$message.success(res.data.message)
            }
          }
        })
      }
    }
  }
}
</script>
<style lang="css" scoped>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    height: 100%;
    background-color: #ffff;
    position: relative;
  }

  .view-loading {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 20000;
    pointer-events: all;
    top: 0;
  }

  .view-noloading {
    width: 1024px;
    height: 768px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    pointer-events: none;
  }
  .fullScreen{
    pointer-events: all;
    width: 600px;
    height: 455px;
    position: absolute;
    z-index: 4;
    top: 245px;
    left: 230px;
    border-radius: 30% / 35%;
    background-color: transparent;
  }
  .tvView {
    pointer-events: all;
    width: 632px;
    height: 485px;
    position: absolute;
    z-index: 4;
    top: 205px;
    left: 315px;
    border-radius: 35% 37% 30% 34%;
    background-color: transparent;
  }

</style>
